export default __webpack_public_path__ + "static/media/Vigil_Mechanism_2.27ac4ead.pdf";